module.exports = {
    GENERIC_ERROR_MESSAGE: "We have encountered an error. If this issue continues, please contact help@uw.edu",

    /*
     * Following are the roles a user might have.
     *
     * Note: The 'professional' role refers to someone who is in the "Doctor of Pharmacy" or "Doctor of Medicine"
     * professional programs. It doesn't mean professional staff or someone who loves school so much they stay and
     * stay.
     */
    UserRoles: {
        student: "STUDENT",
        gradStudent: "GRAD_STUDENT",
        professional: "PROFESSIONAL",
        pce: "PCE",
        adviser: "ADVISER",
        nonStudent: "NON-STUDENT",
        social: "SOCIAL",
        guest: "GUEST",
        devops: "DEVOPS",
    },

    /**
     * Application roles assigned based on group_to_role_mappings
     */
    AppRoles: {
        myplan: "MYPLAN",
        tester: "TESTER",
        admin: "ADMIN"
    },

    IdentityProviders : {
        netId: {
            id: "washington.edu",
            name: "UW NetID"
        },
        google: {
            id: "google",
            name: "Google"
        },
        facebook: {
            id: "facebook",
            name: "Facebook"
        },
        unAuthenticated: {
            id: "unauthenticated",
            name: "UnAuthenticated"
        }
    },

    SessionTypes: {
        guest: "guest",
        netId: "netid",
        social: "social",
        backdoor: "backdoor",
        adviser: "adviser",
    },

    Campuses: {
        seattle: "seattle",
        tacoma: "tacoma",
        bothell: "bothell",
    },

    SDBConstants: {
        recordUpdated: "RECORD UPDATED",
    },

    // NOTE: any headers added here will be automatically be added to the list of allowed CORS headers
    headers: {
        asyncCallback: "x-sis-async-callback-info",
        actAs: "x-act-as",
        relaystate: "x-sis-relaystate",
        apichecksum: "x-sis-api-checksum",
        csrf: "x-csrf-token",
        /** @DEPRECATED by headers.checksum */
        appversion: "x-sis-appversion",
    },

    /*
     * METRICS
     */

    /**
     * These are the names of the metric labels that should be used
     */
    GlobalMetricLabels: {
        /* The source application of the metric */
        application: "Application",
        /* The environment the app is running in (dev, eval, prod) */
        environment: "environment",
        /* The logging level: debug, info, warn */
        loggingLevel: "logging_level",
        /* Is the error expected or not. Is either true or false */
        expected: "expected",
        /* The context in which a component within an application was invoked */
        appContextName: "app_context",
        /* The campus name (e.g. seattle) */
        campus: "campus",
        /* Nav link destination */
        navLinkDestName: "nav_link_dest",
        /* The type of navigation event: global, footer, etc. */
        navType: "nav_type",
        /* The social media provider name (e.g. twitter, facebook). Be sure to keep these consistent. */
        socialMediaService: "social_media_service",
        /* The sort order (e.g. relevance, course_code, course_title) */
        sortByName: "sortby_name",
        /* The name of the tag (e.g. undergraduate, graduate, professional) */
        tabName: "tab_name",
        /* The term id (e.g. 20231) */
        quarter: "quarter",
    },

    /**
     * Metric key names.
     */
    GlobalMetricKeys: {
        error: "error",
        navigation: "nav",
    },

    NextAction: {
        REG_SVCS_NOT_OPEN: 'reg_svcs_not_open', // Registration services haven't opened yet, for anybody
        ACKNOWLEDGE: 'acknowledge', // acknowledges need to be completed
        ADDRESS: 'address', // address verification needs to be done
        PREREG: 'prereg', // UI only state
        BLOCK: 'block', // student has a reg block
        STUDENT_REG_NOT_OPEN: 'student_reg_not_open', // This student's registration period hasn't opened yet
        REGISTER: 'register', // student is ready to register
        SUCCESS: 'success', // reg post was a success
        FAIL: 'fail' // reg post was a failure
    }
}
